// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyAxL99_uPvFFlFV4Sv6OMZR1mhmEZc61Vs',
    authDomain: 'ploutos-34.firebaseapp.com',
    projectId: 'ploutos-34',
    storageBucket: 'ploutos-34.appspot.com',
    messagingSenderId: '1069838795073',
    appId: '1:1069838795073:web:15b2ca1d45badf311261c0',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
